"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NameIdSpace = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../_util/utils");
var _tooltip = _interopRequireDefault(require("../../tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
const NameIdSpace = props => {
  const {
    name,
    id,
    style,
    isEditStyle = false,
    isLinkStyle = false,
    ellipsis,
    disabled,
    disabledTip,
    ...restProps
  } = props;
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
    placement: "top",
    title: !!disabled && disabledTip,
    getPopupContainer: t => t.parentElement,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ...attrs.data,
      className: (0, _classnames.default)('nameIdSpace-wrap', {
        ellipsis,
        isEditStyle,
        isLinkStyle,
        disabled
      }),
      style: style,
      children: [name && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "name",
        children: name
      }), id && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "id",
        children: id
      })]
    })
  });
};
exports.NameIdSpace = NameIdSpace;